const temp_user = (state = null, action) => {
    switch(action.type){
        case 'SET_TEMP_USER' :
            return action.payload
        default:
        return state;
    }
}
export default temp_user